import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.accounts')
  .factory('AccountsCommissionsSummaryApi', AccountsCommissionsSummaryApi);

function AccountsCommissionsSummaryApi(): BringozApi {
  return {
    base: `/accounts/commissions/summary`,
    infiniteScroll: {
      address: `/accounts`,
      cmd: 'GET'
    }
  }
}
